export default class Curtain extends Phaser.Group {
  constructor(game, x, y) {
    super(game);

    this.x = x;
    this.y = y;

    this.touched = false;
    this.time = 5;
    this.zipAngle = 0;

    this.onComplete = new Phaser.Signal();

    this.asset = this.game.make.spine(0, 0, 'spine_curtain', true);
    this.asset.onComplete.addOnce(this.handleAnimComplete, this);
    this.asset.anchor.set(0.5, 1);

    this.addChild(this.asset);
    this.anim = this.asset.setAnimationByName(0, 'animation', false);
    this.anim.timeScale = 0;
    // this.anim.trackTime = 1;

    this.button = this.game.make.button(0, 240, 'empty');
    this.button.anchor.set(0.5);
    this.button.width = 80;
    this.button.height = 240;
    this.addChild(this.button);
    this.button.events.onInputDown.add(this.handleInputDown, this);
    this.button.events.onInputUp.add(this.handleInputUp, this);

    //
    // if (__WATCH__) {
    //   this.game.time.events.add(100, this.handleAnimComplete, this);
    // }
  }

  handleInputDown(target, pointer) {
    target;
    pointer;
    this.pointer = pointer;
    this.drag = true;
    this.dragDY = this.button.y - pointer.y;
    this.touched = true;

    this.game.sounds.checkAudioContext();
  }

  handleInputUp(target, pointer) {
    target;
    pointer;
    this.pointer = null;
    this.drag = false;

    this.unzip();
  }

  handleAnimComplete() {
    this.asset.onComplete.remove(this.handleAnimComplete, this);
    this.onComplete.dispatch();
  }

  unzip() {
    this.button.events.onInputDown.remove(this.handleInputDown, this);
    this.button.events.onInputUp.remove(this.handleInputUp, this);
    this.anim.timeScale = 1;
    this.button.destroy();
    this.button = null;
  }

  update() {
    super.update();
    this.asset.update();

    if (!this.touched) {
      const dt = this.game.time.elapsedMS / 1000;
      if (this.time > 0) {
        this.time -= dt;
        if (this.time <= 0) {
          console.log('show hand');
        }
      }

      // move zip up/down
      const value = -0.5 * (Math.cos(this.zipAngle) - 1);
      this.button.y = 240 - value * 50;
      this.zipAngle += dt * 5;

      this.setZipPosition(this.button.y);
    }

    if (this.drag) {
      let y = this.pointer.y + this.dragDY;
      y = Phaser.Math.clamp(y, -240, 240);
      this.button.y = y;

      this.setZipPosition(y);

      // auto finish anim
      const value = 1 - (y + 240) / 480;
      if (value > 0.8) {
        this.handleInputUp();
      }
    }
  }

  setZipPosition(y) {
    const value = 1 - (y + 240) / 480;
    const time = 1 * value;
    this.anim.trackTime = time;
  }
}
